import { resolveDefaultLanguage } from "@ext/localization/core/model/Language";
import { resolveDefaultTheme } from "@ext/Theme/Theme";
import { Level, setting, Target } from "../logic/settings";

const APP_OR_WORKSPACE = Level.app | Level.workspace;

export const AppSettings = {
	general: {
		language: setting({
			target: Target.all,
			default: resolveDefaultLanguage(),
			availableAt: APP_OR_WORKSPACE,
			clientOverridable: true,
		}),
		theme: setting({
			target: Target.all,
			default: resolveDefaultTheme(),
			availableAt: APP_OR_WORKSPACE,
			clientOverridable: true,
		}),
	},
	services: {
		"git-proxy": setting({
			target: Target.all,
			default: "https://gram.ax/git-proxy/",
			availableAt: APP_OR_WORKSPACE,
		}),
		auth: setting({
			target: Target.all,
			default: "https://gram.ax/auth/",
			availableAt: APP_OR_WORKSPACE,
		}),
		"diagram-renderer": setting({
			target: Target.all,
			default: "https://gram.ax/diagram-renderer/",
			availableAt: APP_OR_WORKSPACE,
		}),
		"web-editor": setting({
			target: Target.desktop,
			default: "https://app.gram.ax",
			availableAt: APP_OR_WORKSPACE,
		}),
		ai: {
			enabled: setting({
				target: Target.all,
				default: false,
				availableAt: APP_OR_WORKSPACE,
			}),
			endpoint: setting<string>({
				target: Target.all,
				availableAt: APP_OR_WORKSPACE,
			}),
			token: setting<string>({
				target: Target.all,
				availableAt: APP_OR_WORKSPACE,
			}),
		},
	},
	enterprise: {
		endpoint: setting<string>({
			target: Target.all,
			availableAt: APP_OR_WORKSPACE,
		}),
		"refresh-interval": setting({
			target: Target.all,
			default: 1800,
			availableAt: APP_OR_WORKSPACE,
		}),
	},
};
